module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar loggedIn = (((storage.user || {}).data || {}).states || {}).authenticated;\n%>\n<div class=\"<%- (loggedIn ? 'loggedIn' : '') %>\">\n<div class=\"head\">\n<div class=\"button add showOnLoggedIn\">\n<i class=\"fi fi-plus-circle\"></i>\n</div>\n<div class=\"button refresh showOnLoggedOut\" title=\"Suche zurücksetzen\">\n<i class=\"fi fi-refresh\"></i>\n</div>\n<h1><%= model.headline || '' %></h1>\n<div class=\"button logout showOnLoggedIn\">\n<i class=\"fi fi-power-off\"></i>\n</div>\n<div class=\"button login showOnLoggedOut\">\n<i class=\"fi fi-sign-in\"></i>\n</div>\n</div>\n<%- helpers.renderSection('filter') %>\n<%- helpers.renderSection('list') %>\n<div class=\"footer\">\n<a href=\"https://www.codeup.at\" target=\"_blank\">\n<div>Programmierung und Betrieb durch</div>\n<img height=\"30px\" src=\"/images/codeup-logo.png\" title=\"CodeUp\" alt=\"CodeUp - Logo\" />\n</a>\n</div>\n</div>"
  , __filename = "components/templates/controller/controller.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var loggedIn = (((storage.user || {}).data || {}).states || {}).authenticated;

    ; __line = 3
    ; __append("\n<div class=\"")
    ; __line = 4
    ; __append( (loggedIn ? 'loggedIn' : '') )
    ; __append("\">\n<div class=\"head\">\n<div class=\"button add showOnLoggedIn\">\n<i class=\"fi fi-plus-circle\"></i>\n</div>\n<div class=\"button refresh showOnLoggedOut\" title=\"Suche zurücksetzen\">\n<i class=\"fi fi-refresh\"></i>\n</div>\n<h1>")
    ; __line = 12
    ; __append(escapeFn( model.headline || '' ))
    ; __append("</h1>\n<div class=\"button logout showOnLoggedIn\">\n<i class=\"fi fi-power-off\"></i>\n</div>\n<div class=\"button login showOnLoggedOut\">\n<i class=\"fi fi-sign-in\"></i>\n</div>\n</div>\n")
    ; __line = 20
    ; __append( helpers.renderSection('filter') )
    ; __append("\n")
    ; __line = 21
    ; __append( helpers.renderSection('list') )
    ; __append("\n<div class=\"footer\">\n<a href=\"https://www.codeup.at\" target=\"_blank\">\n<div>Programmierung und Betrieb durch</div>\n<img height=\"30px\" src=\"/images/codeup-logo.png\" title=\"CodeUp\" alt=\"CodeUp - Logo\" />\n</a>\n</div>\n</div>")
    ; __line = 28
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/controller/controller.ejs

}